<template>
    <b-modal
        id="modalVetsource"
        ref="modalVetsource"
        :lazy="true"
        title-tag="h2"
        hide-footer
        hide-header
        size="xl"
        no-close-on-backdrop
    >
        <div class="msg-dark-bg">
            Do not refresh this page until the Vetsource order is completed.
        </div>

        <div id="vetsource-content">
            <iframe
                id="vetsource-frame"
                :src="iframe.src"
                :height="iframe.style.height"
                :width="iframe.style.width"
                @load="iframeLoaded"
                frameborder="0"
            ></iframe>
        </div>
        <div class="vetsource-cta" v-if="showCTA">
            <div class="mb-1">Have you completed this Vetsource order ?</div>
            <div>
                <div class="btn-group" v-if="!isLoading">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="mapOrder"
                    >
                        Yes
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="removerOrder"
                    >
                        No, remove it from this invoice.
                    </button>
                </div>
                <Loader v-else :margin="0" />
            </div>
        </div>
    </b-modal>
</template>
<style type="text/css">
#vetsource-frame {
    min-width: 730px;
    height: 550px;
}

.vetsource-cta {
    border-top: 5px solid #190d30;
    background: #f6f6f6;
    padding: 1em;
    display: flex;
    align-items: center;
    flex-direction: column;
}

#vetsource-content {
    border: 1px solid #f6f6f6;
}

.msg-dark-bg {
    text-align: center;
    background: #190d30;
    color: #ffffff;
    padding: 1em;
}
</style>

<script>
import Invoice from "@/services/invoice";
import Loader from "@/components/elements/loader";
import InvoiceItemService from "@/services/invoice/invoice-item";

export default {
    components: {
        Loader
    },
    data() {
        return {
            iframe: {
                src: "",
                style: {
                    position: "absolute",
                    width: "100%",
                    height: "600px"
                },
                wrapperStyle: {
                    overflow: "hidden"
                }
            },
            isLoading: false,
            showCTA: false,
            data: null
        };
    },
    methods: {
        open(params) {
            if (params) {
                this.iframe.src = params.vetsourceLink;
                this.data = params;
                this.$refs.modalVetsource.show();
            }
        },
        iframeLoaded() {
            this.showCTA = true;
        },
        mapOrder() {
            this.isLoading = true;
            let self = this;

            Invoice.syncVetsourceOrder({
                invoice_item_id: this.data.itemId,
                client_id: this.data.clientId
            })
                .then(response => {
                    if (response && response.code === 200) {
                        self._message("Vetsource order successfully mapped");
                        self.$refs.modalVetsource.hide();
                    } else {
                        self._message(
                            "Unable to map Vetsource order. The item has been deleted",
                            "danger"
                        );
                        self.$emit("reload");
                    }
                })
                .catch(e => {
                    self._message(
                        "Error occur while mapping vetsource order",
                        "danger"
                    );
                    console.error(e);
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        removerOrder() {
            let self = this;
            self.isLoading = true;

            InvoiceItemService.deleteItem(this.data.itemId)
                .then(response => {
                    if (response && response.code === 200) {
                        self._message(response.message);
                    } else {
                        self._message("Unable to delete item.", "danger");
                    }
                })
                .catch(e => {
                    self._message(
                        "Error occur while deleting the item",
                        "danger"
                    );
                    console.error(e);
                })
                .finally(() => {
                    self.isLoading = false;
                    self.$emit("reload");
                    self.$refs.modalVetsource.hide();
                });
        }
    }
};
</script>
